<template>
  <div
    class="saas-section"
    :class="[
      {
        'saas-section--light-to-dark':
          block.background_gradient == 'light_to_dark',
        'saas-section--dark-to-light':
          block.background_gradient == 'dark_to_light',
      },
    ]"
  >
    <div class="saas-page-multi-slider">
      <div
        class="saas-page-multi-slider__dropdown saas-page-multi-slider__dropdown--padding"
      >
        <Dropdown
          v-model="selectedCategoryIndex"
          :show-search="false"
          size="large"
        >
          <DropdownItem
            v-for="(category, index) in block.categories"
            :key="`category-${index}`"
            :icon="category.icon"
            :name="category.name"
            :value="index"
          ></DropdownItem>
        </Dropdown>
      </div>
      <ul class="saas-page-multi-slider__categories">
        <li
          v-for="(category, index) in block.categories"
          :key="`category-${index}`"
        >
          <a
            class="saas-page-multi-slider__category"
            :class="{
              'saas-page-multi-slider__category--active':
                index === selectedCategoryIndex,
            }"
            @click="setSelectedCategoryIndex(index)"
          >
            <i
              v-if="category.icon"
              class="saas-page-multi-slider__category-icon"
              :class="category.icon"
            ></i>
            {{ category.name }}
            <Badge v-if="category.new" color="cyan" rounded>New</Badge>
          </a>
        </li>
      </ul>
      <div class="saas-page-multi-slider__container-wrapper">
        <div
          v-for="(category, categoryIndex) in block.categories"
          :key="`container-${categoryIndex}`"
          class="saas-page-multi-slider__container"
          :class="{
            'saas-page-multi-slider__container--first': categoryIndex === 0,
            'saas-page-multi-slider__container--visible':
              categoryIndex === selectedCategoryIndex,
          }"
        >
          <div
            v-if="category.image !== null"
            class="saas-page-multi-slider__full-image"
          >
            <img
              :src="category.image.image.src"
              :alt="category.image.image.title"
              :srcset="`${category.retina_image.image.src} 2x`"
              class="saas-page-multi-slider__full-image-img"
            />
          </div>
          <template v-if="category.image === null">
            <div class="saas-page-multi-slider__items-wrapper">
              <div class="saas-page-multi-slider__dropdown">
                <Dropdown
                  v-model="selectedItemIndex[categoryIndex]"
                  :show-search="false"
                  size="large"
                >
                  <DropdownItem
                    v-for="(item, itemIndex) in category.items"
                    :key="`item-${categoryIndex}-${itemIndex}`"
                    :icon="item.icon"
                    :name="item.name"
                    :value="itemIndex"
                  ></DropdownItem>
                </Dropdown>
              </div>
              <ul class="saas-page-multi-slider__items">
                <li
                  v-for="(item, itemIndex) in category.items"
                  :key="`item-${categoryIndex}-${itemIndex}`"
                >
                  <a
                    class="saas-page-multi-slider__item"
                    :class="{
                      'saas-page-multi-slider__item--active':
                        getSelectedItemIndex(categoryIndex) === itemIndex,
                    }"
                    @click="setSelectedItemIndex(categoryIndex, itemIndex)"
                  >
                    <i
                      v-if="item.icon"
                      class="saas-page-multi-slider__item-icon"
                      :class="{
                        [item.icon]: true,
                        [`saas-page-multi-slider__item-icon--${item.color}`]:
                          getSelectedItemIndex(categoryIndex) === itemIndex,
                      }"
                    ></i>
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
            <div class="saas-page-multi-slider__images-wrapper">
              <div class="saas-page-multi-slider__images">
                <div
                  v-for="(item, itemIndex) in category.items"
                  :key="`image-${categoryIndex}-${itemIndex}`"
                  class="saas-page-multi-slider__image"
                  :class="{
                    'saas-page-multi-slider__image--first': itemIndex === 0,
                    'saas-page-multi-slider__image--visible':
                      itemIndex === getSelectedItemIndex(categoryIndex),
                  }"
                >
                  <img
                    :src="item.image.image.src"
                    :alt="item.image.image.title"
                    :srcset="`${item.retina_image.image.src} 2x`"
                    class="saas-page-multi-slider__image-img"
                    :loading="itemIndex > 0 ? 'lazy' : null"
                  />
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageBlockMultiSlider',
  props: {
    block: {
      type: Object,
      required: true,
    },
  },
  data() {
    const selectedItemIndex = {}
    this.block.categories.forEach((category, index) => {
      selectedItemIndex[index] = 0
    })

    return {
      selectedCategoryIndex: 0,
      selectedItemIndex,
    }
  },
  methods: {
    setSelectedCategoryIndex(index) {
      this.selectedCategoryIndex = index
    },
    setSelectedItemIndex(categoryIndex, itemIndex) {
      this.selectedItemIndex[categoryIndex] = itemIndex
    },
    getSelectedItemIndex(categoryIndex) {
      return this.selectedItemIndex[categoryIndex]
    },
  },
}
</script>
